import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    pendenciasDocsystemBegin: null,
    pendenciasDocsystemSuccess: ['relatorio'],
    pendenciasDocsystemFailure: ['error'],
    pendenciasDocsystemClean: null
})

export const consultaPendencias = form => dispatch => {
    dispatch(Creators.pendenciasDocsystemBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/docsystem/pendencias',
        data: form
    })
    .then(response => dispatch(Creators.pendenciasDocsystemSuccess(response.data.relatorio)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
                showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.pendenciasDocsystemFailure(true))
    })
}

export const clean = () => dispatch => dispatch(Creators.pendenciasDocsystemClean())